import React, { Component } from 'react';
import classNames from 'classnames';

const lteIE9 = (() => {
	if (typeof navigator === 'undefined') return false;

	const ie = /MSIE\s(\d+)/.exec(navigator.userAgent);
	return ie && +ie.$1 <= 9;
})();

export function SelectFileButton({ theme, disabled, accept, icon, title, onSelect }) {
	return (
		<div
			className={theme.buttonWrapper}
			title={lteIE9 ? 'IE9 及以下不支持' + title : title}>
			<div
				className={classNames(
					theme.button,
					'select-file',{ disabled: disabled || lteIE9 }
				)}>
				<i className={"qa-ico-" + icon} title={lteIE9 ? 'IE9 及以下不支持插入图片' : '插入图片'} />
				{ !disabled &&
					<input
						style={{ cursor: lteIE9 ? 'not-allowed' : 'pointer' 	}}
						type="file"
						accept={accept}
						onClick={evt => {
							if (lteIE9) {
								evt.preventDefault();
							} else {
								evt.target.value = null;
							}
						}}
						onChange={evt => onSelect(evt.target.files)}
					/>
				}
			</div>
		</div>
	)
}



// WEBPACK FOOTER //
// ./lib/editor/DraftEditor/toolbar/SelectFileButton.jsx